import type { AdminUserBotStatus } from '@upme/contracts';

/** ISO → `YYYY-MM-DD HH:MM` (UTC, как хранится); null → прочерк. */
export function formatDateTime(iso: string | null): string {
  return iso ? iso.replace('T', ' ').slice(0, 16) : '—';
}

/**
 * Производный статус чата с ботом. Блокировка важнее старта: юзер,
 * выгнавший бота, недоступен для рассылок, даже если Start когда-то жал.
 */
export function botStatusOf(user: {
  botStartedAt: string | null;
  botBlockedAt: string | null;
}): AdminUserBotStatus {
  if (user.botBlockedAt) return 'blocked';
  return user.botStartedAt ? 'started' : 'not_started';
}

export const BOT_STATUS_LABEL: Record<AdminUserBotStatus, string> = {
  started: 'Start нажат',
  not_started: 'Без Start',
  blocked: 'Заблокировал',
};

export const BOT_STATUS_VARIANT: Record<AdminUserBotStatus, 'default' | 'outline' | 'destructive'> = {
  started: 'default',
  not_started: 'outline',
  blocked: 'destructive',
};

export function formatUserName(user: { firstName: string | null; lastName: string | null }): string {
  return [user.firstName, user.lastName].filter(Boolean).join(' ') || '—';
}
